'use client'

import type { ComponentProps } from 'react'

import { ZLink } from '@/_components/universal/z-link'

import { useHeaderOrderOnlineNavigateClick } from '../_hooks'

type AHeaderOrderOnlineZLinkProps = ComponentProps<typeof ZLink>

/**
 * Same as {@link ZLink} to `/volne-terminy`, but reloads when the user is already in the order funnel.
 */
export function AHeaderOrderOnlineZLink({
	onClick,
	href = '/volne-terminy',
	...rest
}: AHeaderOrderOnlineZLinkProps) {
	const mergedClick = useHeaderOrderOnlineNavigateClick(onClick)

	return <ZLink href={href} {...rest} onClick={mergedClick} />
}
